import {Column, Entity, PrimaryColumn} from "typeorm"

@Entity()
export class CommsPlan {

	@PrimaryColumn({unique: true})
	comms_plan!: string

	@Column()
	assignable!: boolean

}